"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFetch = exports.Fetch = exports.setDetectBrowser = exports.detectBrowser = void 0;
const detect_browser_1 = require("detect-browser");
exports.detectBrowser = detect_browser_1.detect;
const setDetectBrowser = (detect) => {
    exports.detectBrowser = detect;
};
exports.setDetectBrowser = setDetectBrowser;
const setFetch = (fetch) => {
    exports.Fetch = fetch;
};
exports.setFetch = setFetch;
//# sourceMappingURL=DependencyInjector.js.map